import * as yup from 'yup';

export const schema = yup
  .object({
    des_finalizadora: yup.string().trim().required(),
    tipo_finalizadora: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();

export const finalizadora = yup
  .object({
    des_tecla: yup.string().nullable(true).notRequired(),
    cod_condicao: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_cc: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_categoria: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();
